import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { CalculationMethod } from '@skylab-shared/dataModel';

export type InventoryKindItem = Omit<InventoryKindsInternalItem, 'version'>;

type InventoryKindsInternalItem = {
    readonly version: string;
    readonly useCustomTransactionLocation: boolean;
    readonly name: string;
    readonly defaultCalculationMethod: CalculationMethod;
    readonly customTransactionLocation: string;
    readonly adjustment: boolean;
};

export class InventoryKindQuery extends Query<InventoryKindItem[]> { }

export class InventoryKindQueryHandlerBase implements QueryHandler<InventoryKindQuery, InventoryKindItem[]> {
    private static Url = TaggedUrl.join('inventory/kinds', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: InventoryKindQuery): Promise<InventoryKindItem[]> {
        const { data } = await this.http.get<{ items: InventoryKindsInternalItem[]; }>(InventoryKindQueryHandlerBase.Url);
        return data.items.map(i => ({
            adjustment: i.adjustment,
            customTransactionLocation: i.customTransactionLocation,
            defaultCalculationMethod: i.defaultCalculationMethod,
            name: i.name,
            useCustomTransactionLocation: i.useCustomTransactionLocation
        }));
    }
}
